import { useEffect } from "react";
import AlertService from "legacy-components/alert/AlertService";
import { useAsyncAction } from "modus/components/form/async-actions/AsyncAction";
import ApplicationService from "libs/resources/identity/applications/ApplicationService";
import ApiService, { DeployV2Request } from "../services/ApiService";

export type LegacyDeployCreateParams = {
  backendUrl: string;
  region: string;
  timeout: number;
};

/** Matches develop branch hook: POST publisher/v2/applications/.../deploy */
export const useLegacyApiDeploymentCreator = (
  resourceAppId: string,
  version: string,
  targetUrl: string,
  region: string,
  timeout: number
) => {
  const { state, subscribe } = useAsyncAction(() =>
    ApiService.createVersionDeploymentLegacy(
      resourceAppId,
      version,
      targetUrl,
      region,
      timeout
    )
  );

  const createVersionDeployment = () => {
    subscribe();
  };

  useEffect(() => {
    if (state?.error) {
      AlertService.error({
        message: state?.error?.data?.message,
        id: "CREATEDEPLOYMENT",
      });
    }
  }, [state?.error]);

  return { createDeploymentstate: state, createVersionDeployment };
};

/** Applications / shared: ApplicationService when not regional; ApiService deployV2 when regional */
export const useResourceAppVersionDeploymentCreator = (
  resourceAppId: string,
  version: string,
  supportRegionalDeployments: boolean,
  deployV2Request: DeployV2Request,
  legacyParams: LegacyDeployCreateParams
) => {
  const { state, subscribe } = useAsyncAction(() =>
    supportRegionalDeployments
      ? ApiService.createVersionDeploymentV2(
          resourceAppId,
          version,
          deployV2Request
        )
      : ApplicationService.createVersionDeployment(
          resourceAppId,
          version,
          legacyParams.backendUrl,
          legacyParams.region,
          legacyParams.timeout
        )
  );

  const createVersionDeployment = () => {
    subscribe();
  };

  useEffect(() => {
    if (state?.error) {
      AlertService.error({
        message: state?.error?.data?.message,
        id: "CREATEDEPLOYMENT",
      });
    }
  }, [state?.error]);

  return { createDeploymentstate: state, createVersionDeployment };
};
